// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"67017be3","162":"b32e7abf","171":"06c57502","261":"13a0ae97"}[chunkId] + ".chunk.js";
};